const { postApiCalling } = require('../../common/function');

const fetchFreeUseSubscriptionMessage = async (data = {}) =>
  await postApiCalling('/exams', '/get-model-content', data);

module.exports = { fetchFreeUseSubscriptionMessage };



// WEBPACK FOOTER //
// ./src/services/exams/index.js